import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";

export default function ServiceCategory({ title, lists, updateBlog, currentItemId }) {
  const menuRef = useRef(null);

  const handleMenuKeyDown = (e) => {
    if (!lists || lists.length === 0) return;

    const items = menuRef.current?.querySelectorAll('a[role="menuitem"]');
    if (!items) return;

    const currentIndex = Array.from(items).indexOf(document.activeElement);

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const nextIndex = (currentIndex + 1) % items.length;
      items[nextIndex].focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const prevIndex = (currentIndex - 1 + items.length) % items.length;
      items[prevIndex].focus();
    } else if (e.key === 'Home') {
      e.preventDefault();
      items[0].focus();
    } else if (e.key === 'End') {
      e.preventDefault();
      items[items.length - 1].focus();
    }
  };

  return (
    <>
      {title || lists ? (
        <div className="service-widgets widget_categories">
          {title ? <h3>{title}</h3> : ""}
          {lists ? (
            <ul
              ref={menuRef}
              role="menu"
              onKeyDown={handleMenuKeyDown}
              aria-label="Investment approaches menu"
            >
              {lists.map((item, i) => {
                const handleItemClick = () => {
                  updateBlog(item.blog);
                };

                const handleKeyDown = (e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleItemClick();
                  }
                };

                const isCurrentPage = currentItemId === item.id;

                return (
                  <li
                    key={i}
                    role="none"
                  >
                    <Link
                      to={`/approaches?name=${item.id}`}
                      onClick={handleItemClick}
                      onKeyDown={handleKeyDown}
                      role="menuitem"
                      tabIndex="0"
                      aria-label={`${item.title} investment approach`}
                      aria-current={isCurrentPage ? "page" : undefined}
                    >
                      {item.title} <FiChevronRight className="icon" aria-hidden="true" />
                    </Link>
                  </li>
                );
              })}
            </ul>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
}
